export default {
    title: "Quanos InfoTwin",
};
